import { createTheme } from '@mui/material/styles'
import { ptBR } from '@mui/material/locale'

const LibreFranklin = 'Libre Franklin'
const Roboto = 'Roboto'

export const configureTheme = () =>
  createTheme(
    {
      palette: {
        mode: 'light',
        common: {
          black: '#000',
          white: '#FFF'
        },
        primary: {
          main: '#054672',
          light: '#5F98FF',
          dark: '#2A4070'
        },
        secondary: {
          main: '#2D2D2E',
          light: '#545454',
          dark: '#060608'
        },
        error: {
          main: '#D32F2F',
          light: '#EF5350',
          dark: '#C62828'
        },
        warning: {
          main: '#ED6C02',
          light: '#FF9800',
          dark: '#E65100'
        },
        info: {
          main: '#5ab1fe',
          light: '#03A9F4',
          dark: '#01579B'
        },
        success: {
          main: '#2E7D32',
          light: '#4CAF50',
          dark: '#1B5E20'
        },
        grey: {
          50: '#fafafa',
          100: '#f5f5f5',
          200: '#eeeeee',
          300: '#e0e0e0',
          400: '#bdbdbd',
          500: '#9e9e9e',
          600: '#757575',
          700: '#616161',
          800: '#424242',
          900: '#212121',
          A100: '#f5f5f5',
          A200: '#eeeeee',
          A400: '#bdbdbd',
          A700: '#616161'
        },
        contrastThreshold: 3,
        tonalOffset: 0.2,
        text: {
          primary: 'rgba(0, 0, 0, 0.87)',
          secondary: 'rgba(0, 0, 0, 0.6)',
          disabled: 'rgba(0, 0, 0, 0.38)'
        },
        divider: 'rgba(0,0,0,0.12)',
        background: {
          default: '#fafafa'
        },
        action: {
          active: 'rgba(0, 0, 0, 0.54)',
          hover: 'rgba(0, 0, 0, 0.04)',
          hoverOpacity: 0.04,
          selected: 'rgba(0, 0, 0,0.08)',
          selectedOpacity: 0.08,
          disabled: 'rgba(0, 0, 0, 0.26)',
          disabledBackground: 'rgba(0, 0, 0, 0.12)',
          disabledOpacity: 0.38,
          focus: 'rgba(0, 0, 0, 0.12)',
          focusOpacity: 0.12,
          activatedOpacity: 0.12
        }
      },
      shape: {
        borderRadius: 6
      },
      typography: {
        htmlFontSize: 16,
        fontFamily: `"${Roboto}", "${LibreFranklin}", sans-serif`,
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: {
          fontFamily: ` ${Roboto}, ${LibreFranklin} , sans-serif`,
          fontWeight: 300,
          fontSize: '6rem',
          lineHeight: 1.167,
          letterSpacing: '-0.01562em'
        },
        h2: {
          fontFamily: ` ${Roboto}, ${LibreFranklin} , sans-serif`,
          fontWeight: 300,
          fontSize: '3.75rem',
          lineHeight: 1.2,
          letterSpacing: '-0.00833em'
        },
        h3: {
          fontFamily: ` ${Roboto}, ${LibreFranklin} , sans-serif`,
          fontWeight: 400,
          fontSize: '3rem',
          lineHeight: 1.167,
          letterSpacing: '0em'
        },
        h4: {
          fontFamily: `${Roboto}, ${LibreFranklin} , sans-serif`,
          fontWeight: 400,
          fontSize: '2.125rem',
          lineHeight: 1.235,
          letterSpacing: '0.00735em'
        },
        h5: {
          fontFamily: `${Roboto}, ${LibreFranklin} , sans-serif`,
          fontWeight: 400,
          fontSize: '1.5rem',
          lineHeight: 1.334,
          letterSpacing: '0em'
        },
        h6: {
          fontFamily: `${Roboto}, ${LibreFranklin} , sans-serif`,
          fontWeight: 500,
          fontSize: '1.55rem',
          lineHeight: 1.6,
          letterSpacing: '0.0075em'
        },
        subtitle1: {
          fontFamily: `${Roboto}, ${LibreFranklin} , "Helvetica", "Arial", sans-serif`,
          fontWeight: 500,
          fontSize: '1rem',
          lineHeight: 1.75,
          letterSpacing: '0.00938em'
        },
        subtitle2: {
          fontFamily: `${Roboto}, ${LibreFranklin} , "Helvetica", "Arial", sans-serif`,
          fontWeight: 500,
          fontSize: '0.875rem',
          lineHeight: 1.57,
          letterSpacing: '0.00714em'
        },
        body1: {
          fontFamily: `${Roboto} , "Helvetica", "Arial", sans-serif`,
          fontWeight: 400,
          fontSize: '1rem',
          lineHeight: 1.5,
          letterSpacing: '0.00938em'
        },
        body2: {
          fontFamily: ` ${Roboto} , "Helvetica", "Arial", sans-serif`,
          fontWeight: 400,
          fontSize: '0.875rem',
          lineHeight: 1.43,
          letterSpacing: '0.01071em'
        },
        tituloTabela: {
          fontFamily: ` ${Roboto} , "Helvetica", "Arial", sans-serif`,
          fontWeight: 500,
          fontSize: '0.875rem',
          lineHeight: 1.43,
          letterSpacing: '0.01071em',
          color: '#000!important'
        },
        button: {
          fontFamily: ` ${Roboto} , "Helvetica", "Arial", sans-serif`,
          fontWeight: 500,
          fontSize: '0.875rem',
          lineHeight: 1.75,
          letterSpacing: '0.02857em',
          textTransform: 'uppercase'
        },
        caption: {
          fontFamily: ` ${Roboto} , "Helvetica", "Arial", sans-serif`,
          fontWeight: 400,
          fontSize: '0.75rem',
          lineHeight: 1.66,
          letterSpacing: '0.03333em'
        },
        overline: {
          fontFamily: ` ${Roboto} , "Helvetica", "Arial", sans-serif`,
          fontWeight: 400,
          fontSize: '0.75rem',
          lineHeight: 2.66,
          letterSpacing: '0.08333em',
          textTransform: 'uppercase'
        },
        link: {
          color: '#2196f3',
          cursor: 'pointer',
          fontSize: '0.875rem',
          fontWeight: '500',
          transition: 'all 0.3s',
          '&:hover': {
            color: '#1565c0'
          }
        }
      },
      transitions: {
        duration: {
          complex: 375,
          enteringScreen: 225,
          leavingScreen: 195,
          short: 250,
          shorter: 200,
          shortest: 150,
          standard: 300
        },
        easing: {
          easeIn: 'cubic-bezier(0.4,0, 1, 1)',
          easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
          easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
          sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
        }
      },
      components: {
        MuiBackdrop: {
          styleOverrides: {
            root: {
              backgroundColor: 'rgba(255, 255, 255, 0.65)'
            }
          }
        },
        MuiFormHelperText: {
          styleOverrides: {
            root: {
              '&.MuiFormHelperText-root': {
                textAlign: 'right'
              }
            }
          }
        },
        MuiDialog: {
          styleOverrides: {
            paper: {
              outline: 'none',
              borderRadius: 18
            }
          }
        },
        MuiAccordion: {
          styleOverrides: {
            root: {
              outline: 'none',
              border: '1px solid #eeeeee',
              borderRadius: 4,
              boxShadow: 'none'
            }
          }
        },
        MuiCheckbox: {
          styleOverrides: {
            root: {
              color: '#757575',
              fontWeight: 300,
              '&.Mui-checked': {
                color: '#4989F4'
              },
              '&.Mui-disabled': {
                color: 'rgba(0, 0, 0, 0.38)'
              },
              '&:hover': {
                backgroundColor: 'transparent'
              },
              '&.Mui-focusVisible': {
                backgroundColor: 'transparent'
              },
              '& .MuiTouchRipple-root': {
                display: 'none'
              },
              transition: 'none'
            }
          }
        },
        MuiSwitch: {
          styleOverrides: {
            switchBase: {
              color: '#ffffff',
              '&.Mui-checked': {
                color: '#4989F4'
              },
              '&.Mui-checked + .MuiSwitch-track': {
                backgroundColor: '#4989F4'
              }
            }
          }
        }
      }
    },
    ptBR
  )
